module.exports = __webpack_public_path__ + "static/kendall-e0508cc923eb0b5e68ca6783c53d0f1d.jpg";